import React from 'react';

import { i18n } from '@lingui/core';
import { I18nProvider } from '@lingui/react';
import { nl, fr } from 'make-plural/plurals';

import { messages as messagesFr } from '../../locales/fr/messages';
import { messages as messagesNl } from '../../locales/nl/messages';

import { I18nLoaderProps } from './I18nLoader.types';
import { getLanguageFromUrlParams } from './I18nLoader.utils';

i18n.loadLocaleData({
  nl: { plurals: nl },
  fr: { plurals: fr },
});

i18n.load({
  nl: messagesNl,
  fr: messagesFr,
});

const language = getLanguageFromUrlParams(window.location.pathname);
i18n.activate(language);

// Render Methods
// ---------------------------------------------------------------------- /

export const I18nLoader: React.FunctionComponent<I18nLoaderProps> = ({ children }) => {
  return <I18nProvider i18n={i18n}>{children}</I18nProvider>;
};
